(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["novartis-wecom-portal"] = factory();
	else
		root["novartis-wecom-portal"] = factory();
})(window, function() {
return 